import { IonIcon, IonText } from "@ionic/react";
import { spinnerIcon } from "@/lib/icons/spinner";

export function FullscreenLoadingSpinner({ text }: { text: string }) {
	return (
		<div className="flex h-full flex-col items-center justify-center gap-2">
			<div className="size-10 animate-spin">
				<IonIcon className="fill-brown-400 size-10" icon={spinnerIcon} />
			</div>
			<IonText className="text-brown-600">{text}</IonText>
		</div>
	);
}
